import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { cleanObject } from 'src/app/helpers/utils';
import { APIEndpoint } from 'src/app/models/options/api-endpoint';
import { WebClientService } from './web-client.service';

@Injectable()
export class ClientService {

  constructor(
    protected web:WebClientService
  ) { }

  
  public get = <T>(
    endpoint: APIEndpoint | string,
    params?: { [param: string]: string | string[] }
  ): Observable<T> => this.web.get<T>(endpoint, cleanObject(params))

  public head = <T>(
    endpoint: APIEndpoint | string,
    params?: { [param: string]: string | string[] }
  ): Observable<T> => this.web.head<T>(endpoint, cleanObject(params))

  public post = <T>(
    endpoint: APIEndpoint | string,
    params?: { [param: string]: string | string[] },
    body?: Object
  ): Observable<T> => this.web.post<T>(endpoint, cleanObject(params), body)

  public put = <T>(
    endpoint: APIEndpoint | string,
    params?: { [param: string]: string | string[] },
    body?: Object
  ): Observable<T> => this.web.put<T>(endpoint, cleanObject(params), body)

  public delete = <T>(
    endpoint: APIEndpoint | string,
    params?: { [param: string]: string | string[] }
  ): Observable<T> => this.web.delete<T>(endpoint, cleanObject(params))
}
